<template>
  <div class="flex h-full w-full">
    <div class="absolute inset-0 flex flex-col justify-end bg-gradient-to-r from-black/80 to-50% to-transparent"></div>
    <Container className="relative flex items-center flex-col justify-center gap-y-8 xl:gap-y-14">
      <div class="flex flex-col text-white text-4xl sm:text-5xl lg:text-7xl px-6 leading-[1.2] text-center lg:text-left">
        <div>{{ addressPart1 }}</div>
        <div>{{ addressPart2 }}</div>
      </div>
      <PlayButton 
        @click.native="runTopMedia()" 
        v-if="!getTopFirstPhoto" 
      />
    </Container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import addressMixin from '@/shared/mixins/address';
  import PlayButton from '../PlayButton';
  import Container from '../Container';

  export default {
    name: 'TopContent',
    mixins: [
      addressMixin
    ],
    components: {
      PlayButton,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getDetails', 'getTopVideo', 'getTop360Tour', 'getTopSlideshow', 'getTopFirstPhoto', 'getPrimaryColor']),
      addressPart2Divided () {
        return this.addressPart2.split(',').join('<br>');
      }
    },
    methods: {
      ...mapActions('ui', ['runTopMedia']),
      scrollDown() {
        this.$emit('onClickLink', 'header');
      }
    }
  };
</script>
